import React from 'react'

import { splitOnUrls } from './format'

/** Free text with any bare URLs rendered as links that open in a new tab. */
const Linkify: React.FC<{ text: string | null | undefined }> = ({ text }) => {
  const t = text ?? ''
  const chunks = splitOnUrls(t)
  if (!chunks.some((c) => c.url)) return <>{t}</>
  return (
    <>
      {chunks.map((c, i) =>
        c.url ? (
          <a key={i} href={c.url} target="_blank" rel="noopener noreferrer">
            {c.url}
          </a>
        ) : (
          <React.Fragment key={i}>{c.text}</React.Fragment>
        ),
      )}
    </>
  )
}

export default Linkify
